export default {"src":"/_next/static/media/Hardhat.9eeaf011.svg","height":41,"width":165,"blurWidth":0,"blurHeight":0};